import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between pb-4" }
const _hoisted_2 = { class: "flex gap-x-3" }
const _hoisted_3 = {
  type: "button",
  class: "modal-popup__close"
}
const _hoisted_4 = { class: "text-xl font-bold tracking-wide" }
const _hoisted_5 = { class: "font-semibold text-black-50" }
const _hoisted_6 = {
  key: 0,
  class: "mb-1 mt-4 w-full bg-[#fbede8] p-2 text-center text-sm"
}
const _hoisted_7 = ["value", "max"]
const _hoisted_8 = { class: "leading-6" }
const _hoisted_9 = {
  key: 0,
  class: "leading-6"
}
const _hoisted_10 = {
  key: 1,
  class: "leading-6"
}
const _hoisted_11 = { class: "hide-scrollbar flex flex-col overflow-y-auto pb-80 pt-4 pl-0 pr-[0.6rem]" }
const _hoisted_12 = {
  key: 1,
  class: "center-x absolute top-1/4"
}
const _hoisted_13 = { class: "text-lg font-medium" }
const _hoisted_14 = {
  key: 0,
  id: "discountPlaceholder",
  class: "border-t border-black-20 py-2"
}
const _hoisted_15 = {
  key: 1,
  class: "align-center flex justify-between border-t border-black-20 py-2"
}
const _hoisted_16 = { class: "border-t border-b border-black-20 py-2" }
const _hoisted_17 = { class: "flex items-center justify-between leading-6" }
const _hoisted_18 = { id: "cartSubtotal" }
const _hoisted_19 = { id: "cartDiscount" }
const _hoisted_20 = { class: "flex items-center justify-between leading-6" }
const _hoisted_21 = ["data-original-amount"]
const _hoisted_22 = { class: "flex items-center justify-between py-2 leading-6" }
const _hoisted_23 = { class: "text-lg font-semibold" }
const _hoisted_24 = { id: "cartTotal" }
const _hoisted_25 = { class: "btn-primary w-full p-0 text-lg font-medium" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_cart_drawer_starterset_item = _resolveComponent("cart-drawer-starterset-item")
  const _component_cart_drawer_item = _resolveComponent("cart-drawer-item")
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", _hoisted_3, [
          _createVNode(_component_v_icon, {
            icon: "arrow-left",
            width: 13,
            height: 26,
            flipped: ""
          })
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString($data.locale.cart), 1)
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString($data.data.item_count) + " " + _toDisplayString($data.locale.items), 1)
    ]),
    ($data.items.length > 0 || Object.keys($data.starterSetItems).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($data.hasCustomDiscount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("progress", {
                  value: $options.discountSubtotal,
                  max: $data.targetAmount,
                  class: "my-2 w-full"
                }, null, 8, _hoisted_7),
                _createElementVNode("p", _hoisted_8, _toDisplayString($data.discountText), 1),
                (!$options.discountAmountLeft)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($data.discountActivatedText), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($options.formattedDiscountRemainingAmountText), 1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.starterSetItems, (item) => {
              return (_openBlock(), _createBlock(_component_cart_drawer_starterset_item, {
                key: item.key,
                "starterset-item": item
              }, null, 8, ["starterset-item"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
              return (_openBlock(), _createBlock(_component_cart_drawer_item, {
                key: item.key,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_v_image, {
            lazyloaded: "",
            image: $data.emptyCartIcon,
            class: "mx-auto mb-12 aspect-square w-20 object-cover"
          }, null, 8, ["image"]),
          _createElementVNode("span", _hoisted_13, _toDisplayString($data.locale.cart_empty), 1)
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["shadow-[0_-5px_10px_0px_rgba(0,0,0,0.1) fixed left-0 bottom-0 w-full bg-white p-4 pb-7", $data.items.length == 0 && Object.keys($data.starterSetItems).length == 0 ? 'hidden' : ''])
    }, [
      ($data.showPlaceholder)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!$data.hasCustomDiscount && !$data.hasStoredDiscount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "leading-6 underline underline-offset-1",
                    onClick: _cache[0] || (_cache[0] = $event => ($options.showDiscountApp($event)))
                  }, " + " + _toDisplayString($data.locale.discount_trigger), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (!$data.hasStoredDiscount && $data.hasCustomDiscount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("p", {
                class: _normalizeClass(["w-fit bg-black-100 py-2 px-4 uppercase leading-6 tracking-widest text-white", $data.skeletonClass])
              }, _toDisplayString($data.discountCode), 3),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.removeCustomDiscountCode && $options.removeCustomDiscountCode(...args)))
              }, [
                _createVNode(_component_v_icon, {
                  icon: "close",
                  width: 14,
                  height: 14
                })
              ])
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", null, _toDisplayString($data.locale.subtotal), 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString($options.formattedSubtotal), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center justify-between py-2 leading-6", $data.hasCustomDiscount || $data.hasStoredDiscount ? 'flex' : 'hidden'])
        }, [
          _createElementVNode("span", null, _toDisplayString($data.locale.discount_total), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString($options.formattedDiscount), 1)
        ], 2),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString($data.locale.shipping_fee), 1),
          _createElementVNode("span", {
            id: "cartShipping",
            "data-original-amount": $data.shipping / 100
          }, _toDisplayString($data.shippingFormatted), 9, _hoisted_21)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, _toDisplayString($data.locale.total), 1),
        _createElementVNode("span", _hoisted_24, _toDisplayString($options.formattedTotal), 1)
      ]),
      _createElementVNode("button", _hoisted_25, [
        _createElementVNode("a", {
          class: "block p-4",
          href: "/checkout",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.setCheckoutEvent && $options.setCheckoutEvent(...args)))
        }, _toDisplayString($data.locale.to_checkout), 1)
      ])
    ], 2)
  ], 64))
}